/**
 * Sens de veinage du bois
 */
export enum GrainDirectionEnum {
  horizontal,
  vertical,
}
